/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_Case_Study_DescInputs */

const en_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'll share matching case studies and verified metrics on a call, scoped to what you're building.`)
};

const ar_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سأشارك دراسات حالة مطابقة ومقاييس موثقة في مكالمة, حسب ما تبنيه.`)
};

const bn_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার প্রজেক্টের সঙ্গে মেলে এমন কেস স্টাডি ও যাচাই করা মেট্রিক কলে শেয়ার করব।`)
};

const de_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passende Fallstudien und verifizierte Metriken teile ich in einem Call, zugeschnitten auf das, was Sie bauen.`)
};

const es_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartiré estudios de casos coincidentes y métricas verificadas en una llamada, enfocados a lo que está creando.`)
};

const fr_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je partagerai des études de cas correspondantes et des mesures vérifiées lors d'un appel, en fonction de ce que vous construisez.`)
};

const pt_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilharei estudos de caso correspondentes e métricas verificadas em uma chamada, com escopo definido para o que você está construindo.`)
};

const zh_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我将在电话中分享匹配的案例研究和经过验证的指标，范围仅限于您正在构建的内容。`)
};

const tr_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir görüşmede, oluşturduğunuz şeye göre eşleşen örnek olay incelemelerini ve doğrulanmış ölçümleri paylaşacağım.`)
};

const ru_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На созвоне поделюсь подходящими кейсами и проверенными метриками, под то, что вы строите.`)
};

const pl_svd_case_study_desc = /** @type {(inputs: Svd_Case_Study_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podczas rozmowy udostępnię pasujące studia przypadków i zweryfikowane dane dotyczące tego, co tworzysz.`)
};

/**
* | output |
* | --- |
* | "I'll share matching case studies and verified metrics on a call, scoped to what you're building." |
*
* @param {Svd_Case_Study_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_case_study_desc = /** @type {((inputs?: Svd_Case_Study_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_Case_Study_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_case_study_desc(inputs)
	if (locale === "bn") return bn_svd_case_study_desc(inputs)
	if (locale === "de") return de_svd_case_study_desc(inputs)
	if (locale === "es") return es_svd_case_study_desc(inputs)
	if (locale === "fr") return fr_svd_case_study_desc(inputs)
	if (locale === "pt") return pt_svd_case_study_desc(inputs)
	if (locale === "zh") return zh_svd_case_study_desc(inputs)
	if (locale === "tr") return tr_svd_case_study_desc(inputs)
	if (locale === "ru") return ru_svd_case_study_desc(inputs)
	if (locale === "pl") return pl_svd_case_study_desc(inputs)
	return en_svd_case_study_desc(inputs)
});